import { User } from '../user/user';

export class UserEmployee extends User {
}
